/**
 * Formats a number with spaces as thousands separators
 * @param num - The number to format
 * @returns The formatted number string with spaces
 */
export function formatNumberWithSpaces(num: number): string {
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
}

/**
 * Formats tokens balance with spaces as thousands separators
 * @param num - The number to format
 * @returns The formatted number string with spaces
 */
export function formatTokensNumber(num: number): string {
  const formatedNum = num.toLocaleString("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
  if (formatedNum == "-0") {
    return "0";
  }
  return formatedNum;
}
